module.exports = __webpack_public_path__ + "img/photo-13.5cec7cd0.jpg";